import { render, staticRenderFns } from "./sent.vue?vue&type=template&id=0ef5611f&"
import script from "./sent.vue?vue&type=script&lang=js&"
export * from "./sent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef5611f')) {
      api.createRecord('0ef5611f', component.options)
    } else {
      api.reload('0ef5611f', component.options)
    }
    module.hot.accept("./sent.vue?vue&type=template&id=0ef5611f&", function () {
      api.rerender('0ef5611f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/message/sent.vue"
export default component.exports